import { Backup } from "./backup";

export enum BackupAction {
    SET_BACKUPS = "[BackupAction] SET_BACKUPS",
}

interface SetBackups {
    type: BackupAction.SET_BACKUPS;
    backups: Backup[];
}

export type BackupActionTypes = SetBackups;
